// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.89.0-beta.398c4319c',
  revision: '398c4319c',
  branch: 'develop',
  date: 'Mon, 13 Jul 2026 09:27:51 GMT'
};